import SearchBaseDAO from "./SearchBaseDAO";

class SearchDAO extends SearchBaseDAO {
  private static instance: SearchDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): SearchDAO {
    if (!SearchDAO.instance) {
      SearchDAO.instance = new SearchDAO();
    }
    return SearchDAO.instance;
  }

  public async queryProducts(term: string): Promise<any> {
    const options: any = {
      query: term,
      result_fields: {
        store_id: {
          raw: {},
          snippet: { size: 100, fallback: true },
        },
        gtin: {
          raw: {},
          snippet: { size: 100, fallback: true },
        },
        image_url: { raw: {}, snippet: { size: 100, fallback: true } },
        description: { raw: {}, snippet: { size: 100, fallback: true } },
        sale_type: { raw: {}, snippet: { size: 100, fallback: true } },
        category_first_level: {
          raw: {},
          snippet: { size: 100, fallback: true },
        },
        price: { raw: {}, snippet: { size: 100, fallback: true } },
        name: { raw: {}, snippet: { size: 100, fallback: true } },
        trademark: { raw: {}, snippet: { size: 100, fallback: true } },
        stock: { raw: {}, snippet: { size: 100, fallback: true } },
        brand: { raw: {}, snippet: { size: 100, fallback: true } },
        category_second_level: {
          raw: {},
          snippet: { size: 100, fallback: true },
        },
        id: { raw: {}, snippet: { size: 100, fallback: true } },
      },
      page: { size: 20, current: 1 },
    };

    return this.post(
      `${this.endpoint}/api/as/v1/engines/oba-webapp/search.json`,
      options
    );
  }

  public async suggestProducts(term: string): Promise<any> {
    return this.get(
      `OBA_SEARCH_${term}`,
      `https://oba-webapp-api.azurewebsites.net/api/Product/AutoComplete?SearchWord=${term}`,
    ).then((x: any) => {
      return x.data.results.documents.map((d: any) => d.suggestion);
    });
  }
}

export default SearchDAO;
